/**
 * Головна точка входу React додатку
 * Ініціалізує та рендерить кореневий компонент у DOM
 * @file main.tsx
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

// Отримуємо кореневий DOM елемент
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Не вдалося знайти кореневий елемент з id "root"');
}

// Створюємо React root та рендеримо додаток
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);